import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import Typography from '../../typography'
import { useBreakpoint } from '../../../../hooks/breakpoint'

import styles from '../../../../styles/bantrab/components/blog.module.scss'

const Details = ({ article, ...attrs }) => {
  const breakpoint = useBreakpoint()

  attrs.className = classNames(
    attrs.className,
    {
      [styles.details]: true
    }
  )

  return <section
    className={
      classNames(
        [
          'relative',
          'pt-12',
          'md:pt-0',
          'bg-white'
        ],
        {
          [styles.header]: true
        }
      )
    }>
    <div
      className={
        classNames([
          breakpoint.mdAndUp ? '' : 'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            'items-center',
            '-mx-4'
          ])
        }
        style={
          {
            minHeight: '25rem'
          }
        }>
        <div
          className={
            classNames([
              'relative',
              'px-4',
              'pb-6',
              'pt-12',
              'md:pb-12',
              'md:pt-24',
              'flex',
              'flex-col',
              'justify-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%'
          }}>
          <div
            className={
              classNames(
                [
                  'flex',
                  'items-center',
                  'justify-between',
                  'mb-4'
                ]
              )
            }>
            <Typography
              className={'text-green-500'}>
              {article.category}
            </Typography>
            <Typography>
              {
                moment(article.meta.firstPublishedAt).format('DD/MM/YYYY')
              }
            </Typography>
          </div>
          <Typography
            weight={'black'}
            size={breakpoint.mdAndUp ? 'seven' : 'five'}
            className={'mb-6 tracking-tight'}>
            {article.title}
          </Typography>
          {
            article.newsAuthors.length > 0
              ? (
                <Typography
                  className="mb-2">
                  Por {article.newsAuthors[0].author.fullName}
                </Typography>
              )
              : ''
          }
        </div>
        <div
          className={
            classNames([
              breakpoint.mdAndUp ? 'absolute' : '',
              breakpoint.mdAndUp ? 'top-0' : '',
              breakpoint.mdAndUp ? 'bottom-0' : '',
              breakpoint.mdAndUp ? 'left-1/2' : '',
              breakpoint.mdAndUp ? 'right-0' : '',
              'flex',
              'flex-col',
              'justify-center',
              'items-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%',
            height: breakpoint.mdAndUp ? '100%' : '18rem'
          }}>
          <div
            className={
              classNames([
                'bg-cover',
                'bg-top',
                'h-full',
                'w-full'
              ])
            }
            style={{
              borderRadius: breakpoint.mdAndUp ? '7.5rem 0 0 0' : '0',
              backgroundImage: 'url("' + article.headerImage.meta.downloadUrl + '")'
            }}>
          </div>
        </div>
      </div>
    </div>
  </section>
}

Details.propTypes = {
  article: PropTypes.object
}

export default Details
